import { gql, useQuery } from '@apollo/client';
import { useMutation } from '../hooks';

export const paymentFields = gql`
  fragment PaymentFields on Payment {
    name
    kind
    type
    paymentReportTypeLabel
    amount
    surchargeAmount
    amountMinusRefundAmount
    paidAt
    scheduledAt
    state
    notes
    offlineMethod
    refundState
    refunded
    mechanism
    refunds {
      id
      amount
      reason
      createdAt
      status
    }
    paymentMethod {
      id
      type
      brand
      last4
      mechanism
      displayLabel
      planner {
        id
        fullName
      }
    }
    createdAt
    updatedAt
  }
`;

const query = gql`
  query Payments($eventId: ID!) {
    payments(eventId: $eventId) {
      id
      ...PaymentFields
    }
  }
  ${paymentFields}
`;

const createMutaion = gql`
  mutation CreatePayment($input: CreatePaymentInput!) {
    createPayment(input: $input) {
      payment {
        id
        ...PaymentFields
      }
      errors {
        message
      }
    }
  }
  ${paymentFields}
`;

const updateMutaion = gql`
  mutation UpdatePayment($input: UpdatePaymentInput!) {
    updatePayment(input: $input) {
      payment {
        id
        ...PaymentFields
      }
      errors {
        message
      }
    }
  }
  ${paymentFields}
`;

const refundMutaion = gql`
  mutation RefundPayment($input: RefundPaymentInput!) {
    refundPayment(input: $input) {
      payment {
        id
        ...PaymentFields
      }
      errors {
        message
      }
    }
  }
  ${paymentFields}
`;

const removeMutaion = gql`
  mutation RemovePayment($input: RemovePaymentInput!) {
    removePayment(input: $input) {
      payment {
        id
        ...PaymentFields
      }
      errors {
        message
      }
    }
  }
  ${paymentFields}
`;

export const usePaymentsQuery = ({ eventId }) => {
  const variables = { eventId };
  const skip = !eventId;
  return useQuery(query, { variables, skip });
};

export const useCreatePaymentMutation = (config) =>
  useMutation(createMutaion, config);
export const useUpdatePaymentMutation = (config) =>
  useMutation(updateMutaion, config);
export const useRefundPaymentMutation = (config) =>
  useMutation(refundMutaion, config);
export const useRemovePaymentMutation = (config) =>
  useMutation(removeMutaion, config);
